import { useLocation } from 'react-router-dom';

export const useSearchParams = (paramKeys: string[]): (string | null)[] => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const paramValues = paramKeys.map(key => urlSearchParams.get(key));

  return paramValues;
};
